import { useState } from "react";
import { useLocation, Link, useNavigate } from "react-router";
import { useAuth } from "../hooks/Auth";
import EditPost from "../components/EditPost";

const PostDisplay = () => {
  const { state } = useLocation();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [post, setPost] = useState(state?.post);
  const [showEdit, setShowEdit] = useState(false);

  if (!post) {
    return <div className="post-page">Loading...</div>;
  }

  return (
    <div className="top-margin">
      {showEdit && (
        <EditPost
          post={post}
          token={token}
          onClose={() => setShowEdit(false)}
          onSaved={(updated) => setPost((prev) => ({ ...prev, ...updated }))}
        />
      )}
      <button
      className="back-button"
      onClick={() => navigate(-1)}
      >
      Back
      </button>

      <div className="post-container">
        <h1 className="post-title">{post.image_name}</h1>

        <img src={post.fullImage} alt={post.image_name} className="post-image" />

        <div className="post-info">
          <p><strong>Author:</strong>{" "} 
            <Link to = "/profile"
            state = {{ user: post.creator }}
            style = {{ cursor: "pointer", textDecoration: "none", color: "blue" }}
            >
              {post.profiles.username}
            </Link>
          </p>
          <p><strong>Gallery:</strong>{" "}
            <Link to = "/gallery"
            state = {{creator: post.creator, gallery: post.gallery_name}}
            style = {{ cursor: "pointer", textDecoration: "none", color: "blue" }}
          >
            {post.gallery_name}
          </Link>
          </p>
          <p><strong>Date:</strong> {new Date(post.created_at).toLocaleDateString()}</p>

          {post.creator === user?.id && (
            <button onClick={() => setShowEdit(true)}>Edit</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostDisplay;
